module.exports = __webpack_public_path__ + "static/media/home.cbc6761e.jpg";